<template>
  <div class="w-full bg-white height-100">
    <el-dialog title="" :visible.sync="isShowNewSegment" width="50%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="isShowaddMembers"
      width="50%"
      class="ishidePopup"
      center
    >
      <div>
        <AddMembersTable :segmentid="segmentId" @changeData="changeData" />
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowNew1" width="50%" center>
      <template slot="title">
        <h2 class="font-semibold text-white fsize18">Data Entered</h2>
      </template>

      <div class="">
        <h2 class="font-semibold mb-8 fsize20">Data Analyst</h2>
        <p class="mb-2">
          Data Entered :
          <span class="text-gray font-semibold">{{ enteredData }}</span>
        </p>
        <p class="mb-2">
          Repeated Data Found :
          <span class="text-gray font-semibold">{{ repeatedDatafound }}</span>
        </p>
        <p class="mb-2">
          Inapropriate Data Found:
          <span class="text-gray font-semibold">{{ emptyDataFound }}</span>
        </p>
      </div>

      <div class="mt-8 flex justify-center">
        <vs-button color="primary" @click="isShowNew1 = false"> Okay</vs-button>
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowNew2" width="50%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowNew3" width="50%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowNew4" width="50%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="isShowAddNewContact" width="30%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Contact</h2>
      </div>
      <div>
        <div class="relative">
          <small class="fsize12 bg-white text-dark font-medium">Name</small>

          <el-input
            placeholder="Name"
            v-model="name"
            maxlength="50"
            class="rounded-xl mt-2"
            name="name"
            v-validate="{ required: true, min: 2, regex: /^[A-Za-z ]+$/ }"
            data-vv-validate-on="input|blur"
          />
          <p v-if="errors.has('name')" class="text-danger fsize12 mt-2">
            {{ errors.first("name") }}
          </p>
        </div>
        <div class="relative mt-4">
          <small class="fsize12 bg-white text-dark font-medium">Email ID</small>
          <el-input
            v-validate="'required|email|min:3'"
            data-vv-validate-on="input|blur"
            placeholder="Email Id"
            v-model="email"
            class="rounded-xl mt-2"
            name="email"
          />
          <p v-if="errors.has('email')" class="text-danger fsize12 mt-1">
            {{ errors.first("email") }}
          </p>
        </div>
        <div class="relative mt-4">
          <small class="fsize12 bg-white text-dark font-medium"
            >Phone Number</small
          >
          <el-input
            placeholder="Phone Number"
            v-model="mobile"
            maxlength="10"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            class="rounded-xl mt-2"
            v-validate="{ required: true, max: 10, regex: /^[0-9]*$/ }"
            data-vv-validate-on="input|blur"
            name="mobile"
          />
          <p v-if="errors.has('mobile')" class="text-danger">
            {{ errors.first("mobile") }}
          </p>
        </div>
        <!-- <div class="relative mt-4">
          <small class="fsize12 bg-white text-dark font-medium"
            >Lead Type</small
          >
          <el-select v-model="type" placeholder="Select" class="w-full mt-2">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="grid grid-cols-2 gap-3 mt-4">
          <div class="relative">
            <vs-button
              type="primary"
              class="rounded-lg bg-primary border-0 text-white font-medium fsize14 lg:py-3 mt-3 md:py-3 w-full"
              @click="addMember"
            >
              Save
            </vs-button>
          </div>
          <div class="relative">
            <vs-button
              type="secondary"
              class="rounded-lg bg-secondary border-0 text-white font-medium fsize14 lg:py-3 mt-3 md:py-3 py-2 w-full"
              @click="isShowAddNewContact = false"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      class="ishidePopup"
      :visible.sync="isShowNewssSegment"
      width="30%"
      center
    >
      <div class="">
        <div>
          <h3 class="text-4d4d4d font-semibold fsize18 my-0 leadg text-left">
            Create New Segment
          </h3>
          <p class="text-8f8f8f my-0 pt-1 fsize12 text-left">
            Organize leads for your Campaigns
          </p>
          <div class="relative mt-2">
            <small class="fsize12 bg-white text-dark font-medium"
              >Segment Name</small
            >
            <el-input
              placeholder="Name"
              maxlength="50"
              class="rounded-xl mt-2"
            />
          </div>
        </div>

        <div class="mt-8">
          <h3 class="text-4d4d4d font-semibold fsize18 my-0 leadg text-left">
            Add Segment Audience
          </h3>
          <p class="text-8f8f8f my-0 pt-1 fsize12 text-left">
            Select contacts to group in this segment
          </p>
          <div class="relative mt-2">
            <small class="fsize12 bg-white text-dark font-medium"
              >Lead Type</small
            >
            <el-select v-model="value" placeholder="Select" class="w-full mt-2">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3 mt-8">
          <div class="relative">
            <vs-button
              variant="primary"
              class="rounded-6px bg-primary border-0 text-white font-medium fsize16 lg:py-3 mt-3 md:py-3 w-full sm-fsize14"
            >
              Add
            </vs-button>
          </div>
          <div class="relative">
            <vs-button
              variant="primary"
              class="rounded-6px bg-82 border-0 text-white font-medium fsize16 lg:py-3 mt-3 md:py-3 py-2 w-full sm-fsize14"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="bulkUpload" width="30%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Bulk Upload File</h2>
      </div>
      <div>
        <div>
          <el-card
            class="bg-f7fafe w-full h-205px hfull-elbody shadow-none uploader-border"
          >
            <div class="flex justify-center cursor-pointer h-full items-center">
              <div class="text-center">
                <div class="flex justify-center mb-2">
                  <feather-icon icon="UploadCloudIcon" />
                </div>
                <small class="font-semibold"
                  >Drop files to uploade or<br />
                  <span class="text-primary">browser</span></small
                >

                <input
                  @change="excelFile"
                  type="file"
                  class="choosefilelogo px-7"
                  accept="application/vnd.ms-excel"
                  ref="upload"
                />
              </div>
            </div>
          </el-card>
        </div>
        <p
          v-if="excelfileData"
          class="flex justify-between items-center mt-1 border p-1"
        >
          {{ fileName }}
          <feather-icon
            icon="XIcon"
            svgClasses="w-4 h-4"
            class="cursor-pointer"
            @click="
              () => {
                this.$refs.upload.value = '';
                excelfileData = null;
                fileName = '';
              }
            "
          />
        </p>
        <p class="fsize12 text-dark font-medium mt-4 cursor-pointer">
          <downloadExcel :data="excelData" name="segment.xlsx">
            Click <a>here</a> to download the sample
          </downloadExcel>
        </p>

        <div class="grid grid-cols-2 gap-3 mt-4">
          <div class="relative">
            <vs-button
              type="primary"
              class="rounded-lg bg-primary border-0 text-white font-medium fsize14 lg:py-3 mt-3 md:py-3 w-full sm-fsize14"
              @click="uploadBulk"
            >
              Upload
            </vs-button>
          </div>
          <div class="relative">
            <vs-button
              type="secondary"
              class="rounded-lg bg-secondary border-0 text-white font-medium fsize14 lg:py-3 mt-3 md:py-3 py-2 w-full sm-fsize14"
              @click="
                () => {
                  bulkUpload = false;
                  this.$refs.upload.value = '';
                }
              "
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Organize Your Leads For Your Campaigns
          </h2>
        </div>
      </div>
    </div>

    <div class="flex w-full px-6 py-8 m fixed-top bg-white">
      <div class="w-4/12 pr-8">
        <div class="bg-white rounded-lg py-6 px-4 cust-shadow">
          <div class="">
            <div class="items-center">
              <h1 class="font-semibold text-dark mb-0 text-2xl">My Segments</h1>
              <p class="fsize12 text-8f8f8f mt-1">
                Edit, organize and delete your segments
              </p>
            </div>
            <div
              class="mt-4 grid grid-cols-1 gap-3 pb-32"
              v-if="segmentData.length > 0"
            >
              <div class="w-full mb-2">
                <el-input
                  placeholder="Search"
                  maxlength="50"
                  v-model="searchSegment"
                  class="rounded-xl mt-2"
                />
              </div>
              <div v-for="item in segmentData" :key="item._id">
                <div
                  @click="handleClick(item)"
                  :class="[
                    item.active
                      ? 'flex items-center bg-f4f5f6 shadow border-round p-4 cursor-pointer'
                      : 'flex items-center bg-white shadow border-round p-4 cursor-pointer',
                  ]"
                >
                  <div class="w-10/12">
                    <div class="w-full">
                      <h3 class="col-4f fsize16 mb-0">
                        {{ item.name }}
                      </h3>
                      <!-- <h3 class="col-4f fsize16 mb-0">Segment name</h3> -->
                      <!-- <p class="fsize10 font-medium pt-1 mb-0 col-4f">
                      Group size: 100
                    </p> -->
                    </div>
                  </div>
                  <div class="w-2/12 flex justify-end cursor-pointer">
                    <div @click="handleClick(item)">
                      <img
                        src="@/assets/images/aright.png"
                        class="w-12 h-12 rounded-full"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
                class="flex items-center bg-white shadow-lg border-round p-4"
              >
                <div class="w-10/12">
                  <div class="w-full">
                    <h3 class="col-4f fsize16 mb-0">Segment name</h3>
                    <p class="fsize10 font-medium pt-1 mb-0 col-4f">
                      Group size: 100
                    </p>
                  </div>
                </div>
                <div class="w-2/12 flex justify-end cursor-pointer">
                  <div @click="handleClick('insights')">
                    <img
                      src="@/assets/images/aright.png"
                      class="w-12 h-12 rounded-full"
                    />
                  </div>
                </div>
              </div>
              <div
                class="flex items-center bg-white shadow-lg border-round p-4"
              >
                <div class="w-10/12">
                  <div class="w-full">
                    <h3 class="col-4f fsize16 mb-0">Segment name</h3>
                    <p class="fsize10 font-medium pt-1 mb-0 col-4f">
                      Group size: 100
                    </p>
                  </div>
                </div>
                <div class="w-2/12 flex justify-end cursor-pointer">
                  <div @click="handleClick('insights')">
                    <img
                      src="@/assets/images/aright.png"
                      class="w-12 h-12 rounded-full"
                    />
                  </div>
                </div>
              </div>
              <div
                class="flex items-center bg-white shadow-lg border-round p-4"
              >
                <div class="w-10/12">
                  <div class="w-full">
                    <h3 class="col-4f fsize16 mb-0">Segment name</h3>
                    <p class="fsize10 font-medium pt-1 mb-0 col-4f">
                      Group size: 100
                    </p>
                  </div>
                </div>
                <div class="w-2/12 flex justify-end cursor-pointer">
                  <div @click="handleClick('insights')">
                    <img
                      src="@/assets/images/aright.png"
                      class="w-12 h-12 rounded-full"
                    />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="flex justify-center w-half">
            <el-pagination
              background
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="
                (value) => {
                  currentPage = value;
                  getAllSegments();
                }
              "
              :page-sizes="[10, 20, 30, 40, 50]"
              :per-size="perPage"
              :pagerCount="4"
              :total="totalSegment"
            >
            </el-pagination>
            <div v-if="segmentData.length < 1">
              <div
                class="text-center border bg-white border-small cust-shadowhover p-4 h-36 cursor-pointer"
                @click="isShowNewSegment = true"
                :class="[isShowNewSegment === true ? 'cardtrans' : '']"
              >
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Admin/plus1.svg"
                  class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
                  alt="banh"
                />
                <p
                  class="font-semibold fsize14 pb-0 pt-4 bg-white mb-0 text-8f8f8f"
                >
                  New Segment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-8/12">
        <div class="grid grid-cols-5 gap-4">
          <!-- <div
            @click="getAllContact()"
            :class="[segmentdata === true ? 'cardtrans' : '']"
            class="text-center border bg-white border-small cust-shadowhover p-4 h-36 cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Admin/plus3.svg"
              class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
              alt="banh"
            />
            <p
              class="font-semibold fsize14 pb-0 pt-4 bg-white mb-0 text-8f8f8f wordf"
            >
              All Contacts
            </p>
          </div> -->
          <div
            @click="handleRefresh()"
            :class="[refreshData === true ? 'cardtrans' : '']"
            class="text-center border bg-white border-small cust-shadowhover p-4 h-36 cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Admin/plus3.svg"
              class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
              alt="banh"
            />
            <p
              class="font-semibold fsize12 pb-0 pt-4 bg-white mb-0 text-8f8f8f wordf"
            >
              Refresh Contacts
            </p>
          </div>
          <div
            class="text-center border bg-white border-small cust-shadowhover p-4 h-36 cursor-pointer"
            @click="
              () => {
                isShowAddNewContact = true;
                errors.clear();
              }
            "
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Admin/plus2.svg"
              class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
              alt="banh"
            />
            <p
              class="font-semibold fsize12 pb-0 pt-4 bg-white mb-0 text-8f8f8f wordf"
            >
              Add New Contact
            </p>
          </div>
          <div
            class="text-center border bg-white border-small cust-shadowhover p-4 h-36 cursor-pointer"
            @click="isShowNewSegment = true"
            :class="[isShowNewSegment === true ? 'cardtrans' : '']"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Admin/plus1.svg"
              class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
              alt="banh"
            />
            <p
              class="font-semibold fsize12 pb-0 pt-4 bg-white mb-0 text-8f8f8f wordf"
            >
              New Segment
            </p>
          </div>
          <div
            @click="
              () => {
                bulkUpload = true;
                excelfileData = null;
                fileName = '';
                this.$refs.upload.value = '';
              }
            "
            :class="[bulkUpload === true ? 'cardtrans' : '']"
            class="text-center border bg-white border-small cust-shadowhover p-4 h-36 cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Admin/plus.svg"
              class="object-contain bg-olpink p-3 rounded-full w-12 h-12"
              alt="banh"
            />
            <p
              class="font-semibold fsize12 pb-0 pt-4 bg-white mb-0 text-8f8f8f wordf"
            >
              Bulk Upload
            </p>
          </div>
        </div>

        <div class="mt-6">
          <div class="flex items-center py-2 bordb justify-between gap-3">
            <h2 class="text-2xl text-black" v-if="!segmentdata">My Audience</h2>
            <!-- <div > -->
            <h2 class="text-2xl text-black" v-if="segmentdata">
              {{ Name + " " + "Audience" }}
            </h2>

            <div class="flex gap-4">
              <vs-button
                v-if="segmentdata"
                @click="addMembers(segmentdata)"
                variant="primary"
                class="rounded-lg bg-primary border-0 text-white font-medium fsize14 px-6 py-2 sm-fsize14"
              >
                <div class="flex gap-1 items-center">
                  <FeatherIcon
                    icon="PlusIcon"
                    size="35"
                    class="flex"
                    svgClasses="w-5 h-5"
                  />
                  <p class="fsize12 pl-1">Add User</p>
                </div>
              </vs-button>
              <vs-button
                v-if="segmentdata"
                color="danger"
                class="rounded-lg bg-danger border-0 text-white font-medium fsize14 px-6 py-2 sm-fsize14"
                @click="segmentDelete()"
              >
                <div class="flex gap-1 items-center">
                  <FeatherIcon
                    icon="Trash2Icon"
                    size="35"
                    svgClasses="w-5 h-5 mt-1"
                  />
                  <p class="fsize12 pl-1">Delete Segment</p>
                </div>
              </vs-button>
            </div>
          </div>
          <div class="flex gap-5 mt-6">
            <div class="w-6/12">
              <el-input
                placeholder="Search"
                maxlength="50"
                v-model="searchText"
                class="rounded-xl mt-2"
              />
            </div>
            <!-- <div class="w-3/12">
              <el-select
                v-model="value1"
                multiple
                placeholder="Select"
                class="w-full mt-2"
              >
                <el-option
                  v-for="column in columnData"
                  :key="column"
                  :label="column"
                  :value="column"
                >
                </el-option>
              </el-select>
            </div> -->
            <!-- <div class="w-3/12 flex gap-3">
              <vs-button
                @click="getAllUsers()"
                color="primary"
                class="rounded-6px bg-82 border-0 text-white font-medium fsize10 py-3 w-full sm-fsize10"
              >
                Apply
              </vs-button>
              <vs-button
                @click="
                  () => {
                    if (value1.length > 0) {
                      value1 = '';
                    }
                  }
                "
                class="rounded-6px bg-82 border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
                :color="value1.length === 0 ? 'grey' : 'primary'"
              >
                Reset
              </vs-button>
            </div> -->
          </div>
          <div class="mt-4" v-if="!segmentdata">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
              header-row-class-name="thead-light table-th-color"
            >
              <el-table-column
                v-for="column in columns"
                :key="column"
                :prop="column"
                :label="column"
                min-width="160px"
              >
              </el-table-column>
            </el-table>
            <div></div>
            <div class="w-full items-center flex justify-between mt-6">
              <p>Total Users {{ totalUsers }}</p>
              <el-pagination
                @current-change="
                  (value) => {
                    currentPage = value;
                    if (refreshData == true) {
                      getAllUsers(refreshData);
                    } else {
                      getAll();
                    }
                  }
                "
                :per-size="perPage ? perPage : 1"
                :total="totalUsers"
              ></el-pagination>
            </div>
          </div>
          <div class="mt-4" v-if="segmentdata">
            <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%"
              border
              header-row-class-name="thead-light table-th-color"
            >
              <!-- <el-table-column type="selection" width="70"> </el-table-column> -->
              <el-table-column label="Name" width="120">
                <template v-slot="{ row }">{{
                  row.name ? row.name : row.fullName
                }}</template>
              </el-table-column>
              <el-table-column
                property="mobile"
                width="180"
                label="Phone Number"
              >
              </el-table-column>
              <el-table-column
                property="email"
                label="Email"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column label="Actions" width="120">
                <template v-slot="{ row }">
                  <div class="flex items-center gap-2">
                    <!-- <FeatherIcon
                      icon="EditIcon"
                      size="18"
                      svgClasses="w-4 h-4"
                    /> -->
                    <FeatherIcon
                      @click="handleRemove(row)"
                      icon="XIcon"
                      size="18"
                      svgClasses="w-4 h-4"
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="w-full flex justify-end mt-6">
              <el-pagination
                @current-change="
                  (value) => {
                    currentPage = value;
                    getAllSegmentUsers();
                  }
                "
                :per-size="perPage"
                :total="tableDataLength"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatherIcon from "../../../../components/FeatherIcon.vue";
import AddSegmentTable from "./components/AddSegmentTable.vue";
import AddMembersTable from "./components/addMembersTable.vue";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      searchText: "",
      segmentId: "",
      drawer: false,
      drawer2: false,
      activeName: "first",
      isShowAddNewContact: false,
      isShowNewSegment: false,
      isShowaddMembers: false,
      bulkUpload: false,
      segmentdata: false,
      segmentData: [],
      tableData: [],
      tableDataLength: 0,
      columns: [],
      columnData: [],
      keys: [],
      Name: "",
      values: [],
      excelData: [],
      currentPage: 1,
      perPage: 10,
      totalUsers: 0,
      value1: [],
      isShowNew2: false,
      isShowNew3: false,
      isShowNew4: false,
      isShowNewssSegment: false,
      value: "",
      searchSegment: "",
      options: "",
      excelfileData: null,
      name: "",
      email: "",
      mobile: "",
      type: "",
      emptyDataFound: "",
      enteredData: "",
      repeatedDatafound: "",
      isShowNew1: false,
      refreshData: false,
      fileName: "",
      searchInput: "",
      totalSegment: "",
    };
  },
  components: {
    AddSegmentTable,
    FeatherIcon,
    AddMembersTable,
  },
  methods: {
    searchDes: _.debounce(function () {
      this.getAllUsers();
    }, 500),
    changeData() {
      this.isShowaddMembers = false;
      this.getAllSegments("edited");
    },
    async handleRefresh() {
      this.segmentdata = false;
      this.searchText = "";
      this.searchSegment = "";
      this.getAllSegments();
      // this.getAllUsers(this.refreshData);
      let data = await this.$store.dispatch("user/getAllUsers");
      this.totalUsers = data.registeredUserLength;
      this.tableData = data.registeredUser;
    },
    getAllContact() {
      this.segmentdata = true;
      this.refreshData = false;
      this.getAllUsers();
    },
    handleAddNewSegment() {
      this.isShowNewSegment = false;
      this.getAllSegments();
    },
    handleClick(data) {
      this.segmentdata = true;
      this.segmentId = data._id;
      if (data.audienceId.length > this.perPage) {
        this.tableDataLength = data.audienceId.length;
        let record = [];
        for (let i = 0; i < 10; i++) {
          record.push(data.audienceId[i]);
        }
        this.tableData = record;
      } else {
        this.tableData = data.audienceId;
        this.tableDataLength = data.audienceId.length;
      }
      this.Name = data.name;
      for (let i = 0; i < this.segmentData.length; i++) {
        this.segmentData[i].active = false;
      }
      data.active = true;

      // this.$router.push({ name: name });
    },
    addMembers() {
      console.log(this.segmentid);
      this.isShowaddMembers = true;
    },
    async segmentDelete() {
      this.$swal
        .fire({
          title: "Alert",
          text: "Are you sure you want to delete",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let payload = {
              segmentid: this.segmentId,
            };
            let data = await this.$store.dispatch(
              "segment/SegmentDelete",
              payload
            );
            if (data.code === 200) {
              this.$swal({
                text: "Deleted Successfully",
                icon: "success",

                confirmButtonColor: "#830c81",
                // cancelButtonColor: "#d33",
                confirmButtonText: "Okay",
              });
              await this.getAllSegments();
              await this.getAllUsers();
              this.segmentdata = false;
            }
          }
        });
    },

    handleRemove(item) {
      let payload = {
        id: item._id,
        segmentid: this.segmentId,
      };

      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        showCancelButton: true,
        confirmButtonText: `Yes, Remove ${item.name} `,
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          let data = await this.$store.dispatch(
            "segment/removeMember",
            payload
          );

          if (data.code == 200) {
            console.log(data);
            this.getAllSegments("edited");
          }
        }
      });
    },
    async excelFile(e) {
      // console.log(e.target.files[0], "data");
      this.excelfileData = e.target.files[0];
      // console.log(e.target.files[0].name, "data");
      this.fileName = e.target.files[0].name;
    },
    async uploadBulk() {
      let formData = new FormData();
      formData.append("file", this.excelfileData);

      let data = await this.$store.dispatch("user/bulkUpload", formData);
      this.bulkUpload = false;
      // console.log(data, "data upload");
      this.isShowNew1 = true;
      this.emptyDataFound = data.data.dataempty;
      this.enteredData = data.data.enteredData;
      this.repeatedDatafound = data.data.redundantdata;
    },

    async getAllSegments(status) {
      try {
        let payload = {
          pagination: true,
          perPage: this.perPage,
        };
        if (this.searchSegment) {
          Object.assign(payload, { search: this.searchSegment });
        }
        if (this.currentPage > 1) {
          Object.assign(payload, { page: this.currentPage });
        }
        let data = await this.$store.dispatch("segment/getAllSegment", payload);
        let segment = data.data.registeredUser;
        for (let i = 0; i < this.segmentData.length; i++) {
          Object.assign(this.segmentData[i], { active: false });
        }
        this.segmentData = segment;
        this.totalSegment = data.data.registeredUserLength;

        if (status == "edited") {
          for (let i = 0; i < data.data.registeredUser.length; i++) {
            if (this.segmentId == data.data.registeredUser[i]._id) {
              this.handleClick(data.data.registeredUser[i]);
              break;
            }
          }
        }
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    assign() {
      this.keys = ["name", "email", "mobile"];
    },
    async addMember() {
      try {
        let payload = {
          name: this.name,
          email: this.email,
          mobile: this.mobile,
        };

        this.$validator.validateAll().then(async (result) => {
          if (result) {
            let data = await this.$store.dispatch("user/addMember", payload);

            if (data.code == 200 && data.data.message != "User Already Exist") {
              this.isShowAddNewContact = false;
              this.$swal({
                text: "Successfully Added Member",
                icon: "success",
                confirmButtonColor: "#830c81",
                // cancelButtonColor: "#d33",
                confirmButtonText: "Okay",
              });
              this.resetValidate();
              this.currentPage =
                this.currentPage > 0
                  ? this.currentPage - 1
                  : (this.currentPage = 1);
              let refreshdata = true;
              this.getAllUsers(refreshdata);
              this.name = "";
              this.email = "";
              this.mobile = "";
            } else {
              this.$swal({
                text: "User Already Exists",
                icon: "warning",
                confirmButtonColor: "#830c81",
                // cancelButtonColor: "#d33",
                confirmButtonText: "Okay",
              });
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    resetValidate() {
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
    async getAllSegmentUsers() {
      try {
        let payload = {
          perPage: this.perPage,
          _id: this.segmentId,
        };

        if (this.currentPage > 1) {
          Object.assign(payload, { page: this.currentPage - 1 });
        }

        let data = await this.$store.dispatch(
          "segment/getAllSegmentUser",
          payload
        );

        this.tableData = data.data;
        console.log(this.tableData);

        // this.excelData = [
        //   {
        //     email: data.email,
        //     name: data.name,
        //     mobile: data.mobile,
        //   },
        // ];
        // this.values = Object.values(data.registeredUser[0]);
        // let array = [];
        // array = Object.keys(data.registeredUser[0]);
        // this.columns = array;

        // if (this.value1.length === 0) {
        //   this.columns = array.filter((x) => {
        //     let y = ["name", "email", "mobile"];
        //     return y.includes(x);
        //   });
        //   this.columnData = this.columns;
        // } else {
        //   console.log(this.value1);
        //   this.columns = this.value1;
        //   // this.columns = array.filter((x) => {
        //   //   let y = ["name", "email", "mobile"];
        //   //   return y.includes(x);
        //   // });
        // }
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async getAllUsers(refresh) {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
        };

        if (this.searchInput)
          Object.assign(payload, { search: this.searchInput });
        if (refresh === true) {
          Object.assign(payload, { sorting: "sort" });
        }
        let data = await this.$store.dispatch("user/getAllUsers", payload);
        // for (let index = 0; index < data.registeredUser[0].length; index++) {
        //   this.column.push

        // }
        this.totalUsers = data.registeredUserLength;
        this.tableData = data.registeredUser;

        this.excelData = [
          {
            email: data.registeredUser[0].email,
            name: data.registeredUser[0].name,
            mobile: data.registeredUser[0].mobile,
          },
        ];
        this.values = Object.values(data.registeredUser[0]);
        let array = [];
        array = Object.keys(data.registeredUser[0]);
        // this.columns = array;

        if (this.value1.length === 0) {
          this.columns = array.filter((x) => {
            let y = ["name", "email", "mobile"];
            return y.includes(x);
          });
          this.columnData = this.columns;
        } else {
          this.columns = this.value1;
          // this.columns = array.filter((x) => {
          //   let y = ["name", "email", "mobile"];
          //   return y.includes(x);
          // });
        }
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async getAll() {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
        };

        if (this.searchText) {
          Object.assign(payload, { search: this.searchText });
        }

        let data = await this.$store.dispatch("user/getAllUsers", payload);

        this.totalUsers = data.registeredUserLength;
        this.tableData = data.registeredUser;

        this.excelData = [
          {
            email: data.registeredUser[0].email,
            name: data.registeredUser[0].name,
            mobile: data.registeredUser[0].mobile,
          },
        ];
        this.values = Object.values(data.registeredUser[0]);
        // let array = [];
        // array = Object.keys(data.registeredUser[0]);
        // this.columns = array;

        // if (this.value1.length === 0) {
        //   this.columns = array.filter((x) => {
        //     let y = ["name", "email", "mobile"];
        //     return y.includes(x);
        //   });
        // } else {
        //   this.columns = array.filter((x) => {
        //     let y = ["name", "email", "mobile"];
        //     return y.includes(x);
        //   });
        // }
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async getSearchdata() {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
          search: this.searchText,
        };
        let data = await this.$store.dispatch("user/getAllUsers", payload);

        this.totalUsers = data.registeredUserLength;
        this.tableData = data.registeredUser;

        this.excelData = [
          {
            email: data.registeredUser[0].email,
            name: data.registeredUser[0].name,
            mobile: data.registeredUser[0].mobile,
          },
        ];
        this.values = Object.values(data.registeredUser[0]);
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    searchSegment: {
      handler: debounce(async function (val) {
        if (val) {
          this.getAllSegments();
        } else {
          this.getAllSegments();
        }
      }, 500),
    },
    searchText: {
      handler: debounce(async function (val) {
        if (val) {
          this.getSearchdata();
        } else {
          this.getAll();
        }
      }, 500),
    },
  },
  async mounted() {
    await this.getAllSegments();
    await this.getAllUsers();
    await this.assign();
  },
};
</script>
